import { useEffect } from "react"
import currentReleaseInfo from "@/../release-info.json"
import { SofiaEnvironment } from "@/sofia-environment"

let serviceWorkerRegistrationAttempted = false

export const useRegisterNotificationServiceWorker = () => {
  useEffect(() => {
    if (Notification.permission !== "granted") {
      Notification.requestPermission()
    }

    const registerServiceWorker = async () => {
      if (serviceWorkerRegistrationAttempted) {
        console.log("Service worker registration already attempted")
        return
      }

      serviceWorkerRegistrationAttempted = true

      try {
        if (!("serviceWorker" in navigator)) {
          console.log("Service worker is not enabled for this browser")
          return
        }

        let hasReleaseChanged = true
        // locally we don't serve the release-info.json so we always assume we got an update
        // otherwise we wouldn't be able to update the installed service worker
        if (!SofiaEnvironment.Bff.IsDevelopment) {
          const serviceWorkerVersionSourceCommit = localStorage.getItem("serviceWorkerVersionSourceCommit")
          hasReleaseChanged = serviceWorkerVersionSourceCommit !== currentReleaseInfo.sourceCommit
        }

        if (navigator.serviceWorker.controller) {
          if (hasReleaseChanged) {
            console.log("Service worker already exists but release changed, updating it...")
            const registration = await navigator.serviceWorker.register("/service-worker.js")
            await registration.update()
            console.log("Service worker updated")
            return
          }
        } else {
          console.log("Service worker does not exist, installing it...")
          await navigator.serviceWorker.register("/service-worker.js")
          console.log("Service worker installed")
        }
      } catch (err) {
        console.error("Service worker registration failed", err)
      }
    }

    registerServiceWorker()
  }, [])
}
